const state = {
  reportUpCheckData: {
    ddIsValid: false,
    dsInvalidLevel: '',
    dsInvalidStatus: '',
  },
  invalidCustom:[],
  dsStatusCustom:[],
  reportUpCheckObj:{},
  reportFormPms:{},
  reportFormLink:{
    205:'promotion_index',
    206:'promotion_channel',
    207:'promotion_statistics',
    208:'promotion_state',
    209:'promotion_month',
    210:'promotion_year',
    211:'promotion_advertising',
    212:'promotion_consultation',
    213:'promotion_province',
    214:'promotion_city',
    215:'promotion_keyword',
    216:'promotion_invalid',
    217:'invite_index',
    218:'invite_analysis',
    219:'invite_state',
    220:'introduce_index',
    221:'introduce_count',
    222:'introduce_month',
    223:'introduce_year',
    224:'introduce_staff',
    225:'introduce_regular',
    227:'finance_index',
    226:'store_index',
    228:'finance_month',
    229:'others_contact',
    230:'others_weChat',
    231:'introduce_major',
    232:'store_salesCenter',
    237:'store_wx',
    233:'introduce_service',
    234:'introduce_source',
    235:'introduce_consultation',
  }
}

const getters = {
  reportUpCheckData: state => {
    return state.reportUpCheckData
  },
  invalidCustom:state=>{
    return state.invalidCustom
  },
  dsStatusCustom:state => {
    return state.dsStatusCustom
  },
  reportUpCheckObj:state => {
    return state.reportUpCheckObj
  },
  reportFormPms:state=>{
    return state.reportFormPms
  },
  reportFormLink:state=>{
    return state.reportFormLink
  }
}

const mutations = {
  setReportUpCheckData(state, data) {
    state.reportUpCheckObj = data
  },
  setInvalidCustom(state,data){
    state.invalidCustom = data
  },
  setDsStatusCustom(state,data){
    state.dsStatusCustom = data
  },
  setReportFormPms(state,data){
    state.reportFormPms = data
  },
}


const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}




// WEBPACK FOOTER //
// ./src/store/model/plugin.js